import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { PLATFORM_REALTIME_REPORT_ID } from './platformRealtimeReportId';

const emptyColumns = [FIELDS.PLATFORM_CODE].map(createFooterMapper(PLATFORM_REALTIME_REPORT_ID));

export const platformReportFooterColumnDefinition = [...emptyColumns];
